// FILE HAS CODE COMMENTED CODE
import React from "react";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { RoleService } from "app/_services/RoleService/RoleService";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { SITETYPE, USERROLE } from "./Constant";
import localStorageService from "app/services/localStorageService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";

// import {
//   ehsPermissions,
//   incidentLevels,
//   trainingLevels,
//   workPermitLevels,
//   workPermitExcavationLevels,
// } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/WorkPermitProcesses/permissionLevels";

class AddRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //   ...ehsPermissions,
      name: "",
      roleLable: "",
      siteType: "",
      // add: false,
      // edit: false,
      // approve: false,
      // editAfterApprove: false,
      // view: false,
      // deleteFlag: false,
      // download: false,
      // dashboard: false,
      error: {},
      id: this.props.match.params.id ? this.props.match.params.id : "",
      projectData: {},
      changeRoute: "",
      auth_user: localStorageService.getItem("auth_user"),
    };
  }

  componentDidMount() {
    if (this.state.id) {
      this.setRoleData();
    }
  }

  async setRoleData() {
    const response = await RoleService.RoleByID(this.state.id);

    if (!response?.status || !response?.data) return toastr.warning("Wrong");

    //const permissionNames = JSON.parse(response.data.permissionNames);
    // const ehsPermission = JSON.parse(response.data.ehsPermissions);

    // const permissions = {
    //   add: permissionNames?.add || false,
    //   edit: permissionNames?.edit || false,
    //   approve: permissionNames?.approve || false,
    //   editAfterApprove: permissionNames?.editAfterApprove || false,
    //   view: permissionNames?.view || false,
    //   deleteFlag: permissionNames?.delete || false,
    //   download: permissionNames?.download || false,
    //   dashboard: permissionNames?.dashboard || false,
    // };

    // Object.keys(ehsPermissions).forEach(key => {
    //     permissions[key] = ehsPermission[key] || false;
    // })

    this.setState({
      name: response.data.title,
      roleLable: response.data.roleLable,
      siteType: response.data.siteType,
      description: response.data.description,
    });
  }

  onChange = (e) => {
    const {
      target: { type, value, name, checked },
    } = e;

    this.setState({ changeRoute: 1 });

    // if (type === "checkbox") {
    //   const updates = { [name]: checked };

    //   if (checked) {
    //     if (name === "add" || name === "editAfterApprove") {
    //       updates.edit = true;
    //       updates.view = true;
    //     }
    //     if (name === "edit") updates.view = true;
    //     if (name === "approve") updates.view = true;
    //     if (name === "download") updates.view = true;
    //     if (name === "deleteFlag") updates.view = true;
    //   }

    //   return this.setState(updates);
    // }

    // let checkNagetiveForValue = value !== "" ? value : "";
    // let flag = 0;
    // if (checkNagetiveForValue !== "") {
    //   flag = checkNagetiveForValue.slice(0, 1) === "-" ? 1 : 0;
    // }
    // if (flag === 0) {
    //   this.setState({
    //     [name]: value,
    //     approve: +value === 5 ? false : this.state.approve,
    //   });
    // } else {
    this.setState({ [name]: value });
    //}
  };

  onSubmit = async (e) => {
    e.preventDefault();

    // const permissionNames = {
    //   add: this.state.add,
    //   edit: this.state.edit,
    //   approve: this.state.approve,
    //   editAfterApprove: this.state.editAfterApprove,
    //   view: this.state.view,
    //   delete: this.state.deleteFlag,
    //   download: this.state.download,
    //   dashboard: this.state.dashboard,
    // };

    // const ehsPermission = {};

    // Object.keys(ehsPermissions).forEach(key => {
    //     ehsPermission[key] = this.state[key] || false;
    // })

    const obj = {
      title: this.state.name,
      roleLable: this.state.roleLable,
      siteType: this.state.siteType || null,
      description: this.state.description.trim(),
      //permissionNames,
      // ehsPermissions: ehsPermission
    };

    const data = this.state.id
      ? await RoleService.updateRole(this.state.id, obj)
      : await RoleService.createRole(obj);

    if (data && data.status === 1) {
      this.setState({ changeRoute: "" });
      if (this.state.id) {
        toastr.success("Role Updated Successfully");
      } else {
        toastr.success("Role Created Successfully");
      }
      this.props.history.push("/user-management/roles");
    } else if (data && data.message) {
      toastr.warning(data.message);
    }
  };

  render() {
    // const {
    //   add,
    //   edit,
    //   approve,
    //   editAfterApprove,
    //   view,
    //   deleteFlag,
    //   download,
    //   dashboard,
    //   roleLable,
    // } = this.state;
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
            { name: "User Management", path: "#" },
            { name: "Roles", path: "/user-management/roles" },
            { name: this.state.id ? "Edit" : "Add" },
          ]}
          breadCrumbsText="User_Management_Roles"
        />
        <Prompt changes={this.state.changeRoute}></Prompt>
        <div className="row d-flex justify-content-center">
          <div className="col-md-10">
            <div className="card mt-0 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">
                    {this.state.id ? "Edit" : "Add"} Role
                  </h3>
                </div>
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Role</label>
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Enter Role Name"
                        onChange={this.onChange}
                        value={this.state.name}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Level</label>
                      <SimpleSelect
                        name="roleLable"
                        className="form-control"
                        value={this.state.roleLable}
                        onChange={(e) => this.onChange(e)}
                        id="value"
                        label="name"
                        options={USERROLE.filter(
                          (d) => this.state.auth_user?.user?.role?.roleLable < d.value
                        )}
                        init="Select"
                      ></SimpleSelect>
                      {/* <select
                        className="form-control"
                        name="roleLable"
                        value={this.state.roleLable}
                        onChange={this.onChange}
                        required
                      >
                        <option value="">Select</option>
                        {USERROLE.map((d) => {
                          return this.state.auth_user?.user?.role?.roleLable <

                            d.value ? (
                            <option value={d.value}> {d.name}</option>
                          ) : null;
                        })}
                      </select> */}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Site Type</label>
                      <SimpleSelect
                        name="siteType"
                        className="form-control"
                        value={this.state.siteType}
                        onChange={(e) => this.onChange(e)}
                        id="value"
                        label="name"
                        options={SITETYPE}
                        init="Select"
                      ></SimpleSelect>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Description</label>
                      <textarea
                        name="description"
                        // type="textarea"
                        className="form-control"
                        placeholder="Enter Description"
                        onChange={this.onChange}
                        value={this.state.description}
                        required
                      />
                    </div>
                  </div>
                  {/* CODE TO BE REMOVED */}
                  {/* <h5 className="mb-2">General Permission</h5>
                  <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                  <div className="row">
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="add"
                          checked={add}
                          value={add}
                          onChange={this.onChange}
                        />
                        <span>Add</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="edit"
                          checked={edit}
                          value={edit}
                          onChange={this.onChange}
                        />
                        <span> Edit</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="approve"
                          checked={approve}
                          value={approve}
                          onChange={this.onChange}
                          disabled={+roleLable === 5}
                        />
                        <span>Approve</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="editAfterApprove"
                          checked={editAfterApprove}
                          value={editAfterApprove}
                          onChange={this.onChange}
                        />
                        <span>Edit After Approve</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="view"
                          checked={view}
                          value={view}
                          onChange={this.onChange}
                        />
                        <span>View</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="deleteFlag"
                          checked={deleteFlag}
                          value={deleteFlag}
                          onChange={this.onChange}
                        />
                        <span>Delete</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="download"
                          checked={download}
                          value={download}
                          onChange={this.onChange}
                        />
                        <span>Download</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="checkbox checkbox-primary mb-4">
                        <input
                          type="checkbox"
                          name="dashboard"
                          checked={dashboard}
                          value={dashboard}
                          onChange={this.onChange}
                        />
                        <span>Dashboard</span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <h5 class="mb-2">EHS Permissions</h5>
                                    <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                                    <label className="mb-2">EHS Permissions (Training Management)</label>
                                    <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                                    <div className="row">
                                        {Object.keys(trainingLevels).map((levelKey, index) => (
                                            <div key={index} className="col-md-4">
                                                <label className="checkbox checkbox-primary mb-4">
                                                    <input type="checkbox" name={trainingLevels[levelKey].key} checked={this.state[trainingLevels[levelKey].key]} onChange={this.onChange} />
                                                    <span>{trainingLevels[levelKey].title}</span>
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    <label className="mb-2">EHS Permissions (Incident Management)</label>
                                    <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                                    <div className="row">
                                        {Object.keys(incidentLevels).map((levelKey, index) => (
                                            <div key={index} className="col-md-4">
                                                <label className="checkbox checkbox-primary mb-4">
                                                    <input type="checkbox" name={incidentLevels[levelKey].key} checked={this.state[incidentLevels[levelKey].key]} onChange={this.onChange} />
                                                    <span>{incidentLevels[levelKey].title}</span>
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    <label className="mb-2">EHS Permissions (Permit to Work)</label>
                                    <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                                    <div className="row">
                                        {Object.keys(workPermitLevels).map((levelKey, index) => (
                                            <div key={index} className="col-md-4">
                                                <label className="checkbox checkbox-primary mb-4">
                                                    <input type="checkbox" name={workPermitLevels[levelKey].key} checked={this.state[workPermitLevels[levelKey].key]} onChange={this.onChange} />
                                                    <span>{workPermitLevels[levelKey].title}</span>
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>

                                    <label className="mb-2">EHS Permissions (Excavation)</label>
                                    <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />
                                    <div className="row">
                                        {Object.keys(workPermitExcavationLevels).map((levelKey, index) => (
                                            <div key={index} className="col-md-4">
                                                <label className="checkbox checkbox-primary mb-4">
                                                    <input
                                                        type="checkbox"
                                                        name={workPermitExcavationLevels[levelKey].key}
                                                        checked={this.state[workPermitExcavationLevels[levelKey].key]}
                                                        onChange={this.onChange}
                                                    />
                                                    <span>{workPermitExcavationLevels[levelKey].title}</span>
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        ))}
                                    </div> */}

                  <div className="col-md-12 text-center">
                    <Link to="/user-management/roles" className="btn btn-secondary mr-2">
                      Back
                    </Link>
                    <button className="btn btn-primary ml-2">
                      {this.state.id ? "Update" : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddRoles;
